import { permitir_numerar_o_diario_de_classe } from "./permitir-numerar-o-diario-de-classe/permitir-numerar-o-diario-de-classe";
import { emitir_diario_de_classe } from "./emitir-diario-de-classe/emitir-diario-de-classe";
import { renumeracao_automatica_diario_de_classe } from "./renumeracao-automatica-diario-de-classe/renumeracao-automatica-diario-de-classe";
import { des_bloquear_a_numeracao_do_diario_de_classe } from "./des-bloquear-a-numeracao-do-diario-de-classe/des-bloquear-a-numeracao-do-diario-de-classe";
import { permitir_consultar_matricula_diaria_por_escola } from "./permitir-consultar-matricula-diaria/permitir-consultar-matricula-diaria-por-escola";

const diario_de_classe_da_turma = [
  permitir_numerar_o_diario_de_classe,
  emitir_diario_de_classe,
  renumeracao_automatica_diario_de_classe,
  des_bloquear_a_numeracao_do_diario_de_classe,
  permitir_consultar_matricula_diaria_por_escola,
];

export { diario_de_classe_da_turma };
